module.exports = __webpack_public_path__ + "static/media/LOADERpage_Doorright.5d40fd4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADERpage_Doorright.png
// module id = 323
// module chunks = 0